/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import { Pagination } from 'sarsaparilla';

interface UGCPaginationProps {
    /** This is the index of the first item on the current page. For example, if the page size is 5, the start value for the third page would be 15 */
    start: number | null;
    /** The total number of items being paginated (not the total number of pages) */
    total: number | null;
    /** The number of items per page */
    pageSize: number | null;
    /** change handler called with the index of the next active page index */
    onPage: (page: number) => void;
}

function handleScrollClick() {
    const ugcGalleryWrap = document.getElementById(
        'ugc-story-gallery-top'
    ) as HTMLElement; // Assert that getElementById will not return null

    ugcGalleryWrap.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
    });
}

export default function SearchPagination({
    start: startProp,
    total: totalProp,
    pageSize: pageSizeProp,
    onPage,
}: UGCPaginationProps) {
    // Because some silly people are sending null values ...
    const start = startProp ?? 0;
    const total = totalProp ?? 0;
    const initialPageSize = pageSizeProp ?? 20;

    // Calculate pagination values from the raw prop data
    const pageSize = total < initialPageSize ? total : initialPageSize;
    const pageCount = Math.ceil(total / pageSize);
    const activePage = Math.floor(start / pageSize);

    return (
        <div className="ugc-pagination-wrap" aria-describedby="ugc-pagination-results">
            <div className="ugc-pagination" id="search-pagination-results">
                {pageCount > 1 ? (
                    <Pagination
                        aria-label="Share Your Story Results Pagination"
                        pages={pageCount}
                        activePage={activePage}
                        onChange={(newPage) => {
                            if (onPage) {
                                onPage(newPage + 1);
                                handleScrollClick();
                            }
                        }}
                    />
                ) : null}
            </div>
        </div>
    );
}

SearchPagination.propTypes = {
    start: PropTypes.number,
    total: PropTypes.number,
    pageSize: PropTypes.number,
    onPage: PropTypes.func,
};
